import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppContext, AppProvider } from './AppContext';
import Auth from './auth/Auth';
import AuthRoute from './auth/AuthRoute';
import { AuthRoutes } from './enums/RouteEnums';
import { ThemeProvider } from '@mui/material/styles';
import { buildTheme } from './utils/theme';
import { Box } from '@mui/material';
import Navigation from './components/Navigation/Navigation';
import Message from './components/Common/Message';
import Confirmation from './components/Common/Confirmation';
import { IRouteModel } from './Routes';

export function App() {
  const { state } = useContext(AppContext);
  const appRoutes: IRouteModel[] = [];
  state.routes.forEach((r) => {
    r.subRoutes ? r.subRoutes.forEach((sr) => appRoutes.push(sr)) : appRoutes.push(r);
  });

  return (
    <ThemeProvider theme={buildTheme()}>
      <AppProvider>
        <Auth>
          <Router>
            <Box sx={{ display: 'flex' }}>
              <Navigation />
              <Routes>
                {appRoutes.map((r, index) => (
                  <Route
                    key={index}
                    path={r.path}
                    element={
                      <AuthRoute
                        isPublic={r.isPublic as boolean}
                        requiredRole={r.requiredRole}
                        Component={r.Component as React.FunctionComponent}
                      />
                    }
                  />
                ))}
                <Route path="*" element={<Navigate to={AuthRoutes.Home} />} />
              </Routes>
              <Message />
              <Confirmation />
            </Box>
          </Router>
        </Auth>
      </AppProvider>
    </ThemeProvider>
  );
}
